<app-form-field-wrapper [label]="label" [name]="name" [colSize]="colSize">
  <p-dropdown
    id="bookmarkDropdown"
    [filter]="true"
    [(ngModel)]="selection"
    (ngModelChange)="onChange($event)"
    [filterFields]="['title']"
    [options]="bookmarks"
    optionLabel="name"
    optionValue="_id">
    <ng-template pTemplate="selectedItem" let-selectedOption>
      <div class="flex gap-2 align-items-center">
        <i class="fas fa-note-sticky w-2rem text-center"></i>
        <span>{{ selectedOption.title }}</span>
      </div>
    </ng-template>
    <ng-template let-item pTemplate="item">
      <div class="flex gap-2 align-items-center">
        <div class="flex gap-2 align-items-center">
          <i class="fas fa-note-sticky w-2rem text-center"></i>
          <span>{{ item.title }}</span>
        </div>
      </div>
    </ng-template>
  </p-dropdown>
</app-form-field-wrapper>
